import numbers from '../numbers'


export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "Select",
            data: {
                type: "options",
                placeholder: "Выберите из списка",
                selected: settings[name],
                onChange,
                options: numbers
            }
        }
    ]
}